import type { ReactNode } from 'react';

import { Modal } from './Modal';

/**
 * A small confirmation dialog built on the shared Modal — the in-app
 * replacement for window.confirm. The caller owns the open state and the
 * confirm action (so it can show a pending state during the round-trip).
 */
export function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  destructive = false,
  pending = false,
  confirmDisabled = false,
  eyebrow,
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
  pending?: boolean;
  /** Disables ONLY the confirm button (form invalid) — Cancel stays live. */
  confirmDisabled?: boolean;
  eyebrow?: string;
}) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      eyebrow={eyebrow}
      title={title}
      width={440}
      footer={
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 'var(--sp-2)' }}>
          <button className="btn btn--ghost btn--sm" onClick={onClose} disabled={pending}>
            {cancelLabel}
          </button>
          <button
            className={`btn btn--sm ${destructive ? 'btn--destructive' : 'btn--primary'}`}
            onClick={onConfirm}
            disabled={pending || confirmDisabled}
          >
            {pending ? 'Working…' : confirmLabel}
          </button>
        </div>
      }
    >
      <div className="t-sm" style={{ margin: 0 }}>
        {message}
      </div>
    </Modal>
  );
}
